import React from 'react';
import styled, { css } from 'styled-components';
import { media } from '../themes/theme';
const StyledWrapper = styled.div `
  position: relative;
  height: 1.875rem;
  background-color: ${(props) => props.backgroundColor || 'transparent'};
  transform: ${({ layout }) => (layout === 'topLeft' && 'scale(-1, 1)') ||
    (layout === 'bottomLeft' && 'scale(-1, -1)') ||
    (layout === 'bottomRight' && 'scale(1, -1)') ||
    'none'};

  ${media.tablet `
    height: 3.375rem;
  `};

  ${({ isInverted, layout }) => isInverted
    ? css `
          position: absolute;
          width: 100%;
          z-index: 5;
          ${layout === 'topLeft' || layout === 'topRight'
        ? css `
                top: 0;
              `
        : css `
                bottom: -1px;
              `}
        `
    : css `
          svg {
            position: absolute;
            top: 1px;
          }
        `}
`;
const StyledCurve = styled.svg `
  width: 100%;
  height: 100%;
`;
export function Curve({ layout = undefined, color = 'transparent', backgroundColor = 'transparent', isInverted = false, className, }) {
    return (React.createElement(StyledWrapper, { layout: layout, backgroundColor: backgroundColor, isInverted: isInverted, className: className },
        React.createElement(StyledCurve, { xmlns: "http://www.w3.org/2000/svg", width: "1440", height: "53", viewBox: "0 0 1440 53", preserveAspectRatio: "none" },
            React.createElement("path", { fill: color, fillRule: "evenodd", d: isInverted
                    ? 'm956.28 0c-89.002-.014-181.844 2.604-273.506 6.69-297.314 13.251-582.22 41.94-682.774 46.31v-53zm483.72 53c-103.825-39.665-283.891-52.953-483.421-53h483.421z'
                    : 'M0 53c201.107-8.74 1139.624-114.754 1440 0H0z' }))));
}
